<c3-config-section-box
  [title]="TP_SECTIONS_INFO['goals'].label"
  [icon]="TP_SECTIONS_INFO['goals'].icon"
>
  
  <div config-description>
    <p>{{ TP_SECTIONS_INFO["goals"].description }}</p>

    <p class="d-flex flex-row justify-start items-center gap-12">
      <mat-icon mat-message-icon svgIcon="information" color="primary"></mat-icon>
      <span>Può essere attivato un solo goal alla volta</span>
    </p>
  </div>

  <div [c3ConfigForm]="this">
    <mat-table [dataSource]="dataSource" matSort>
      
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="flex-5">
          
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-5">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onSelectionChange(row)"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Goal</mat-header-cell>

        <mat-cell *matCellDef="let goal" class="row start-center">
          <span>{{ goal.label }}</span>
        </mat-cell>
      </ng-container>

      
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Data d'inizio</mat-header-cell>

        <mat-cell *matCellDef="let goal" class="row start-center">
          <mat-form-field compact>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              [(ngModel)]="goal.startDate"
              (ngModelChange)="onStartDateChange()"
              [disabled]="!selection.isSelected(goal)"
              readonly
              [min]="today"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</c3-config-section-box>
